export default __webpack_public_path__ + "static/media/link_banner.3d64946d.png";